import BaseService from './baseService';

class User extends BaseService {
	async getUsers(opts = {}) {
		this.endPoint = '/users';
		return this.get(opts);
  }
	async getUserById(id,opts = {}) { 
		this.endPoint = '/users/' + id;
		return this.get(opts);
  }
	async getCompanyById(id,opts = {}) { 
		this.endPoint = '/company/' + id;
		return this.get(opts);
  }
  async getUserByName(payload,opts={}){
    this.endPoint = `/search-by-name?q=${payload.q}`;
    return this.get(opts);
  }
	async getUsersCompany(opts = {}) {
		this.endPoint = '/users-by-company';
		return this.get(opts);
  }
	async getUsersUnverified(opts = {}) {
		this.endPoint = '/search-unverified-users';
		return this.get(opts);
  }
	async getUsersByEmailOrPhone(query, opts = {}) {
		this.endPoint = '/search-by-email-phone-pos?q=' + query;
		return this.get(opts);
  }
	async getRoles(opts = {}) {
		this.endPoint = '/role';
		return this.get(opts);
  }
  async createUser(payloadUser){
    this.endPoint = '/users';
    
    return await this.post(payloadUser); 
  }
  async updateUser(payloadUser,opts={}){
    this.endPoint = '/users';
    return await this.put(payloadUser,opts); 
  }
  async activatedUser(id,opts={}){
    this.endPoint = '/activedUser/'+id;
    return await this.put(id,opts); 
  }
  async deleteUser(id,opts={}){
    this.endPoint = '/users';
    return await this.delete(id,opts);
  }
  async forgotPassword(payload) {
    this.endPoint = '/forgot_password';
    return this.post(payload);
  }
}

export default new User();